import { LINKEDCALENDAR_ENTRY_TYPE } from './constants';

/**
 * Returns whether provided calendar entry is for linked calendar
 * @param calendarEntry, the calendar entry
 * @returns true if calendar entry is for linked calendar
 */
export function isLinkedCalendar(calendarEntry: { __type?: string }): boolean {
    return calendarEntry.__type == LINKEDCALENDAR_ENTRY_TYPE;
}
